import type { RecipeInput } from '@fitness/api-client';
import { Link, createFileRoute, useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

import { PageHeader } from '@/components/PageHeader';
import { RecipeEditor } from '@/components/food/RecipeEditor';
import { describeError } from '@/lib/api';
import { SAVED, showToast } from '@/lib/toast';
import { useCreateRecipe } from '@/lib/queries/recipes';

export const Route = createFileRoute('/_app/food/recipes/new')({
  component: NewRecipePage,
});

function NewRecipePage() {
  const navigate = useNavigate();
  const create = useCreateRecipe();

  function handleSubmit(input: RecipeInput): void {
    create.mutate(input, {
      onSuccess: (recipe) => {
        showToast(SAVED.recipeCreated);
        void navigate({ to: '/food/recipes/$id', params: { id: recipe.id } });
      },
    });
  }

  return (
    <>
      <PageHeader
        title="Nueva receta"
        subtitle="Pon los ingredientes y nosotros calculamos las macros."
        action={
          <Link
            to="/food/recipes"
            aria-label="Volver a las recetas"
            className="flex size-11 items-center justify-center rounded-xl border border-line text-ink-muted transition-colors hover:bg-surface-raised active:bg-surface-raised"
          >
            <ArrowLeft className="size-5" aria-hidden="true" />
          </Link>
        }
      />

      <RecipeEditor
        onSubmit={handleSubmit}
        submitting={create.isPending}
        errorTitle="No se ha podido crear la receta"
        errorMessage={create.isError ? describeError(create.error, { saving: true }) : undefined}
        submitLabel="Crear receta"
        onCancel={() => void navigate({ to: '/food/recipes' })}
      />
    </>
  );
}
